<div
  fcomTrapFocus
  role="dialog"
  [attr.aria-label]="'chat.preChatAriaLabel' | finLocalization"
  class="chatPosition fixed chatWindow white-bg"
>
  <div class="chatWrapper relative">
    <header class="chatHeader grid-col-12 no-row-gap grid-max-width white-bg">
      <div class="col-f">
        <div class="fill flex ps-small-y">
          <div class="flex-1 flex--basis0 flex flex--start flex--self-center"></div>

          <div class="flex-1 flex flex--center flex--self-center">
            <fcom-icon class="finnair-emblem" name="finnair-emblem" category="custom"></fcom-icon>
          </div>

          <div class="flex-1 flex--basis0 flex flex--end flex--self-center align-right">
            <button
              (click)="chatToggle.emit(HelpButtonStatus.VISIBLE)"
              [attr.title]="'actions.minimize' | finLocalization"
              [attr.aria-label]="'actions.minimize' | finLocalization"
              class="link-hover ms-small-r focus-inset"
              #minimize
            >
              <fcom-icon name="minimise-chat"></fcom-icon>
            </button>
            <button
              (click)="chatToggle.emit(HelpButtonStatus.VISIBLE)"
              [attr.title]="'actions.close' | finLocalization"
              [attr.aria-label]="'actions.close' | finLocalization"
              class="link-hover focus-inset"
            >
              <fcom-icon name="close-delete"></fcom-icon>
            </button>
          </div>
        </div>
      </div>
    </header>
    <div class="chatBody pr-small">
      <h3 class="align-center">{{ 'chat.welcomeMessage' | finLocalization }}</h3>
      <p class="light-type align-center pr-small-x pr-medium-b pr-xsmall-t">
        {{ 'chat.subtitle' | finLocalization }}
      </p>

      <button
        class="link-hover align-left flex flex--center fill focus-inset"
        tabindex="0"
        (click)="startChat.emit()"
        data-test-start-chat
        [attr.title]="'actions.startChat' | finLocalization"
        [attr.aria-label]="'actions.startChat' | finLocalization"
      >
        <div class="flex flex-1 flex--middle mr-xsmall-r">
          <fcom-icon class="ir-medium mr-xsmall-r" name="chat-block"></fcom-icon>
          <div>
            <p class="font-body-1">{{ 'chat.buttonHeading' | finLocalization }}</p>
            <p class="light-type">{{ 'chat.buttonSubHeading' | finLocalization }}</p>
          </div>
        </div>
        <fcom-icon class="flex-1 flex--nogrow rotate ir-xsmall" name="chevron-right"></fcom-icon>
      </button>

      <fin-expand
        *ngFor="let item of availableAccordions$ | async; let index = index"
        [id]="chatExpandKey + '-' + index"
        [key]="chatExpandKey"
        [clearSelectionOnDestroy]="true"
        class="block ps-medium-t"
        #expand
      >
        <div class="trigger flex flex--center">
          <div class="flex flex-1 flex--middle mr-xsmall-r">
            <fcom-icon name="{{ item.localSettings?.iconName }}" class="ir-medium mr-xsmall-r"></fcom-icon>
            <span class="font-body-1" [innerHTML]="item.teaserTitle"></span>
          </div>
          <fcom-icon
            name="chevron-down"
            class="flex-1 flex--nogrow rotate ir-xsmall"
            [class.rotate-active]="expand.isOpen$ | async"
          ></fcom-icon>
        </div>
        <div class="content">
          <div *ngIf="expand.isOpen$ | async" class="font-body-1 pr-small-t" [innerHTML]="item.teaserText"></div>
        </div>
      </fin-expand>
    </div>
  </div>
</div>
